<template>
  <div>
    <div>slider</div>
    <SjSlider
      :range="range"
      v-model="value"
      :step="step"
      :getLabel="v => `value: ${v}%`"
    />
    <SjSlider
      style="width: 200px"
      :range="range"
      v-model="value"
      :step="step"
      :getLabel="v => `value: ${v}%`"
      theme="fill"
    />
    <SjSlider
      :range="range"
      v-model="value"
      :step="step"
      :getLabel="v => `value: ${v}%`"
      showRange
    />
    <div>{{ value }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      range: [0, 100],
      value: 10,
      step: 0.5
    };
  }
};
</script>

<style scoped lang="less"></style>
